import { Box, CircularProgress } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import { RouteErrorBoundary } from 'components/route-errors';
import { ContentLoader } from 'components/route-loaders';
import type { JSX } from 'react';
import { lazy, Suspense } from 'react';

const SubscriptionInfo = lazy(() => import('pages/subscription'));

const Loader = (): JSX.Element => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
    <CircularProgress />
  </Box>
);

export const Route = createFileRoute('/_authenticated/_main/subscription')({
  pendingComponent: () => <ContentLoader minHeight="50vh" />,
  errorComponent: RouteErrorBoundary,
  component: SubscriptionWrapper,
});

function SubscriptionWrapper(): JSX.Element {
  return (
    <Suspense fallback={<Loader />}>
      <SubscriptionInfo />
    </Suspense>
  );
}
